(function(app, $) {
    var $cache = {};

    function initializeCache() {
        $cache.body = $('body');
        $cache.window = $(window);
        $cache.forms = $cache.body.find('form.valid-form');
    }

    function initializeEvents() {
        /**
         * Check required element on blur input
         */
        $cache.body.on('blur', '[required="required"]', function() {
            checkElement($(this));
        });

        /**
         * Check phone or mobile number on submit
         */
        $cache.forms.each(function() {
            var $form = $(this);

            $form.on('submit', function() {
                var $phone = $('input[name="phone"]');
                var $mobile = $('input[name="mobile"]');

                if($phone.length > 0 && $mobile.length > 0) {
                    if($phone.val().length > 0 || $mobile.val().length > 0) {
                        return true;
                    }
                    else {
                        if($phone.val.length == 0) {
                            $phone.addClass('input-error');
                        }
                        else {
                            $phone.removeClass('input-error');
                        }

                        if($mobile.val().length == 0) {
                            $mobile.addClass('input-error');
                        }
                        else {
                            $mobile.removeClass('input-error');
                        }
                    }
                }

                return false;
            });
        });
    }

    function checkElement(elem) {
        if(elem.val().length > 0) {
            elem.removeClass('input-error');
        }
        else {
            elem.addClass('input-error');
        }

        if(elem.attr('type') === 'email' && elem.is(':required')) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(!re.test(elem.val())) {
                elem.addClass('input-error');
            }
            else {
                elem.removeClass('input-error');
            }
        }
    }

    app.components = app.components || {};
    app.components.form = {
        init : function() {
            if(app.preferences && app.preferences.modules.enableContactUsForm) {
                initializeCache();
                initializeEvents();
            }
        }
    };
}(window.app = window.app || {}, jQuery));
